import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import Background from './../Components/Background.js';
import Grid from './../Components/Grid';
import Logo from './../Components/Header/Logo';
import RegistrationForm from './../Components/SignUp/RegistrationForm';
import './../../../../Css/lpGeneral.css';
import LpContainer from './../Components/LpContainer.js';
import css from '../../../../css/phf.css';
import StatsSender from '../../../socialMedia/StatsSender.js';

const wmaster = 'https://imlive.com/wmaster2.ashx';
const destination = `${wmaster}`;
const queryString = new URLSearchParams(location.search);


let currDomain = location.hostname.toLowerCase().replace('www.', '');
currDomain = queryString.get('currDomain') || currDomain;

console.log(currDomain);
let domainName = currDomain.split('.')[0];




const statsSender = new StatsSender(`phf_${domainName}`);
statsSender.sendEvent(statsSender.actions.impression);
let callXXXDev = {
    wid: 126680735880,
    nickname: 'AmelyAngelx',
    img_bio: `/Content/images/Jennifer/All-bio-${queryString.get('nickname') || 'Jennifer'}.webp`,
    img_bg: `/Content/images/Jennifer/bg-${queryString.get('nickname') || 'Jennifer'}.webp`,
    img_logo: '/Content/images/Jennifer/ImLivelogo.png',
    skipCode: false
}

let callXXX_com = {
    wid: 126680735880,
    nickname: 'AmelyAngelx',
    img_bio: '/Content/images/All-bio-AmelyAngelx.webp',
    img_bg: '/Content/images/bg-Jennifer.webp',
    img_logo: '/Content/images/ImLivelogo.png',
    skipCode: false
}

let callonline_com = {
    wid: 126680735880,
    nickname: 'AmelyAngelx',
    img_bio: '/Content/images/All-bio-Jennifer.webp',
    img_bg: '/Content/images/bg-Jennifer.webp',
    img_logo: '/Content/images/ImLivelogo.png',
    skipCode: false
}


let bestlivecam_com = {
    wid: 126680649465,
    nickname: 'AlmaGamboa_',
    img_bio: '/Content/images/All-bio-AlmaGamboa.webp',
    img_bg: '/Content/images/bg-AlmaGamboa.webp',
    img_logo: '/Content/images/ImLivelogo.png',
    skipCode: false
}

let kittyscam_com = {
    wid: 126682353075,
    nickname: 'AnnieSkye',
    img_bio: '/Content/images/All-bio-AnnieSkye.webp',
    img_bg: '/Content/images/bg-AnnieSkye.webp',
    img_logo: '/Content/images/ImLivelogo.png',
    skipCode: true
}

let configByModel = {
    'w01.23live.com': callXXXDev,
    'callxxx.com': kittyscam_com,
    'callonline.com': callonline_com,
    'bestlivecam.com': bestlivecam_com,
    'mysafe.com': bestlivecam_com,
    'kittyscam.com': callXXX_com,
    'camkey.com': kittyscam_com
}


let config = configByModel[currDomain] || callXXX_com;

if (!localStorage.getItem('imagePreloaded')) {
    const img = new Image();
    img.src = config.img_bio;
    img.onload = () => {
        localStorage.setItem('imagePreloaded', 'true');
    };
}

function App(props) {


    const [discountSubmitted, setDiscountSubmitted] = useState(localStorage.getItem('discountSubmitted') === 'true');
    const [discountCode, setDiscountCode] = useState('');
    const [autoLoginUrl, setAutoLoginUrl] = useState(localStorage.getItem('autoLoginUrl') || '');
    const [showError, setShowError] = useState(false);
    const [incorrectCodeSumbitted, setIncorrectCodeSubmitted] = useState(false);
    const shouldSkipCodeStage = config.skipCode;
    const stepToSet = autoLoginUrl ? <Slide2 /> : <Slide1 />;
    const [step, setStep] = useState(stepToSet);
    const [currentSlide, setCurrentSlide] = useState(autoLoginUrl ? 2 : 1);


    const handleDiscountSubmit = () => {
        const codeInput = document.getElementById('discount-code');

        if (codeInput && codeInput.value == 127922) {
            localStorage.setItem('discountSubmitted', 'true');
            statsSender.sendEvent(statsSender.actions.submit_code_correct);

            setDiscountSubmitted(true);
            setShowError(false);
        } else {
            statsSender.sendEvent(statsSender.actions.submit_code_incorrect);

            setShowError(true);
        }
    };

    function Slide1() {

        const formConfig = {
            domain: "imlive.com",
            wid: config.wid,
            linkid: queryString.get('linkid') || 701,
            promocode: statsSender.getImpressionId(),
            onSuccess: (autoLoginUrlLink) => {
                let url = new URL(autoLoginUrlLink);
                url.searchParams.set('nickname', config.nickname);
                autoLoginUrlLink = url.toString();
                setAutoLoginUrl(autoLoginUrlLink);
                localStorage.setItem('autoLoginUrl', autoLoginUrlLink);
                statsSender.sendEvent(statsSender.actions.signup_success);
                setCurrentSlide(2)
                setStep(<Slide2 />)
            },
            action: queryString.get('action') || "",
            text: {
                nickNamePLCHLDR: "Username",
                emailPCHLDR: "Email",
                passwordPLCHLDR: "Password"
            },
            onSignupStatusUpdate: ({ status, msg }) => {
                statsSender.sendEvent(status, msg);
            },
            preSubmit: (data) => {
                data.perimpid = localStorage.getItem('impressionId');
            }
        };

        return (
            <Grid
                container
                align="center"
                flexDirection="row"
                justifyContent="center"
                style={{ minHeight: "100vh" }}

            >
                <Grid className='cln' id='page1-main-grid' item >

                    <Grid item margin="20px 0">
                        <Logo src={config.img_logo} />
                    </Grid>
                    <Grid item margin="20px 0 auto" style={{ minHeight: "69px", color: '#000' }}>
                        <h1>Follow Bella instructions<br />I am waiting...</h1>
                        <h2>Register, then we can <br />go all the way </h2>
                    </Grid>
                    <Grid item style={{ maxWidth: 200, margin: "30px auto 0", paddingBottom: '32px' }}>
                        <RegistrationForm config={formConfig} />
                    </Grid>
                </Grid>

            </Grid>
        );
    };

    function Slide2() {
        return (
            <Grid
                container
                align="center"
                flexDirection="row"
                justifyContent="center"
                style={{ minHeight: "100vh", padding: 0 }}

            >
                <div id='page2-main-wrapper'>
                    <img id='page2-main-image' src={config.img_bio} />
                    <div id='discount-wrapper'>
                        <div id='discount-row-1'>
                            <span id='price'>
                                <b>
                                    <span id='minutes' style={discountSubmitted ? {
                                        position: 'relative',
                                        display: 'inline-block',
                                        fontWeight: 'normal',
                                        color: '#B8BDD7'
                                    } : {}}>
                                        {!shouldSkipCodeStage && 13}
                                        {discountSubmitted && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                width: '120%',
                                                height: '2px',
                                                backgroundColor: '#B8BDD7',
                                                transform: 'translate(-50%, -50%) rotate(-45deg)',
                                                transformOrigin: 'center',
                                                zIndex: '1'
                                            }}></div>
                                        )}
                                    </span>
                                    {(discountSubmitted || shouldSkipCodeStage) && <span style={{ marginLeft: '8px' }}><b>26</b></span>} Min.
                                </b> 1-on-1 for $58.95
                            </span>
                            <span id='go-to-site'
                                className={`${autoLoginUrl && (discountSubmitted || shouldSkipCodeStage) ? 'beatAnimation' : 'disabled'}`}
                                onClick={autoLoginUrl && (discountSubmitted || shouldSkipCodeStage) ?
                                    () => {
                                        statsSender.sendEvent(statsSender.actions.redirect_to_site);
                                        window.location.href = autoLoginUrl
                                    } : undefined}>
                                Take It
                            </span>
                        </div>
                        <div id='discount-row-2'>
                            {(discountSubmitted || shouldSkipCodeStage) ? (
                                <div style={{
                                    textAlign: 'left',
                                    color: '#FFF',
                                    fontFamily: 'Rubik',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 'normal',
                                    opacity: 0.9,
                                    padding: '8px'

                                }}>{shouldSkipCodeStage ? 'Ready to go!' : 'Code Verified'}</div>
                            ) : (
                                <>
                                    <div id='discount-row-2-1'>
                                        Want 2x the time alone with me?<br />
                                        Add the coupon code:
                                    </div>
                                    <div id='discount-row-2-2'>
                                        <input id='discount-code' type='number' placeholder='Enter Code' style={{ appearance: 'textfield' }} />
                                        <div id='discount-code-submit' onClick={handleDiscountSubmit}>
                                            Submit
                                        </div>
                                    </div>
                                    {showError && (
                                        <div style={{
                                            color: 'white',
                                            backgroundColor: 'red',
                                            padding: '4px 8px',
                                            fontSize: '12px',
                                            marginTop: '4px'
                                        }}>
                                            Incorrect code, Try again
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </Grid>


        );
    };



    useEffect(() => {

        if (autoLoginUrl) {
            setStep(<Slide2 />);
        } else {
            setStep(<Slide1 />);
        }
    }, [discountSubmitted, autoLoginUrl, showError]);

    return (
        <LpContainer dontRedirect >
            <Background
                fixeBackgroundImage={currentSlide === 1 ? config.img_bg :
                    window.innerWidth > 768 ? config.img_bg : ''}
                watchResize={true}
                overlay=""
                children={step}
                onLoad={
                    () => {

                    }
                }
            >
            </Background>
        </LpContainer>
    );

}

export default App;

ReactDOM.render(<App />, document.getElementById('app'));
